<div class="popup-overlay">
    <div class="popup-content">
        <div>
            <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                [videoOptions]="videoOptions" [imageQuality]="1" (cameraSwitched)="cameraWasSwitched($event)"
                (initError)="handleInitError($event)"></webcam>
            <br />
            <button *ngIf="showWebcam" class="filled-dynamic-color" (click)="triggerSnapshot();">Take A Snapshot</button>
            <br />
            <!-- <button class="filled-dynamic-color" (click)="showNextWebcam(true);" *ngIf="multipleWebcamsAvailable">Next
                Webcam</button> -->
            <!-- <input id="cameraSwitchCheckbox" type="checkbox" [(ngModel)]="allowCameraSwitch"><label
                for="cameraSwitchCheckbox">Allow Camera Switch</label> -->
            <br />
            <!-- DeviceId: <input id="deviceId" type="text" [(ngModel)]="deviceId" style="width: 500px"> -->
            <!-- <button (click)="showNextWebcam(deviceId);">Activate</button> -->
        </div>

        <div class="snapshot" *ngIf="webcamImage">
            <h2>Nice one!</h2>
            <img [src]="webcamImage.imageAsDataUrl" />
            <br>
            <br>
            <button class="btn btn-primary filled-dynamic-color" (click)="saveImage()">Save</button>
            <button class="btn outline-dynamic-color" (click)="retryImage()">Retry</button>
        </div>
        <button class="btn outline-dynamic-color" (click)="closePopup()">Cancel</button>
        <h4 *ngIf="errors.length > 0">Messages:</h4>
        <ul *ngFor="let error of errors">
            <li>{{error | json}}</li>
        </ul>
    </div>
</div>